module.exports = __webpack_public_path__ + "static/media/Artboard10.bf2f2286.png";